import React from 'react'
import { AppContext } from '../../App'
import * as Request from '../../utilities/request'

import { Col, Row } from 'react-bootstrap'
import { Loading } from '../ui/Loading/Loading'
import { properCase, roundToTwo } from '../../utilities/format'
import { RecentUtilisation, UtilisationPeriod } from '../../../../back-end/common/billyDashboard'
import DashboardCard from './dashboardCard'
import { TrendingDown, TrendingUp } from 'react-feather'
import { TestingStaff } from '../../screens/dashboard/dashboardWrapper'

interface SelfUtilisationProps {
	period: UtilisationPeriod
	testingStaff?: TestingStaff
}

const SelfUtilisation = (props: SelfUtilisationProps) => {
	const { appState } = React.useContext(AppContext)

	const [recentUtilisation, setRecentUtilisation] = React.useState<RecentUtilisation | null>(null)
	const [errorMsg, setErrorMsg] = React.useState<string | null>(null)

	React.useEffect(() => {
		const getData = async () => {
			const testingStaffXpmID = props.testingStaff ? '/' + props.testingStaff.xpmID : ''
			const utilRes = await Request.get(`billydashboard/util${testingStaffXpmID}?period=${props.period}`)

			setRecentUtilisation(utilRes.data.recentUtilisation)

			if (!utilRes.data.success) {
				setErrorMsg(utilRes.data.message)
			}
		}

		if (appState.authState.isLoggedIn) {
			getData()
		}
	}, [appState.authState, props])

	if (errorMsg) {
		return (
			<DashboardCard background={props.period}>
				<div className="center-flex p-3">
					<span className="span-body-2 span-white">{errorMsg}</span>
				</div>
			</DashboardCard>
		)
	}

	if (!recentUtilisation) {
		return (
			<DashboardCard background={props.period}>
				<div className="center-flex">
					<Loading show style={{ color: 'white' }} />
				</div>
			</DashboardCard>
		)
	}

	const utilDelta = roundToTwo(
		((recentUtilisation.currentPeriod.percentUtilised - recentUtilisation.previousPeriod.percentUtilised) /
			recentUtilisation.previousPeriod.percentUtilised) *
			100
	)
	const incDec = utilDelta >= 0 ? 'increase' : 'decrease'

	const utilDeltaValid = !isNaN(utilDelta) && utilDelta !== Number.NEGATIVE_INFINITY && utilDelta !== Number.POSITIVE_INFINITY

	return (
		<DashboardCard background={props.period}>
			<Row>
				<Col className="d-flex flex-column">
					<span className="span-body-2 span-bold span-white">UTILISATION THIS {recentUtilisation.period.toUpperCase()}</span>
					<div>
						<span className="font-800-40-48 span-white">{recentUtilisation.currentPeriod.percentUtilised}</span>
						<span className="font-800-24-48 span-white">%</span>
					</div>
					<span className="span-body-2 span-white">{recentUtilisation.currentPeriod.billableHours} hrs Invoiceable</span>
				</Col>
				<Col className="d-flex flex-column justify-content-between align-items-end">
					<div className="d-flex flex-column align-items-end">
						<span className="span-body-2 span-white">Last {properCase(recentUtilisation.period)}</span>
						<div>
							<span className="font-700-16-24 span-white">{recentUtilisation.previousPeriod.percentUtilised}</span>
							<span className="font-700-12-24 span-white">%</span>
						</div>
					</div>
					{utilDeltaValid && (
						<span className="font-800-12-14 span-white">
							{incDec === 'increase' ? <TrendingUp size={14} /> : <TrendingDown size={14} />}
							<span className="pl-1">
								{Math.abs(utilDelta)}% {incDec} on last {recentUtilisation.period}
							</span>
						</span>
					)}
				</Col>
			</Row>
		</DashboardCard>
	)
}

export default SelfUtilisation
